import { useState, useEffect } from 'react';

import { functions } from '../../firebase';

const grantIpAccess = functions.httpsCallable('grantIpAccess');
// 許可フラグの有効期限(5分)より短くし、更新の切れ目でデータが読めなくなるのを防ぐ
const pollingInterval = 4 * 60 * 1000;

const isPermissionDenied = e => (e?.code || '').endsWith('permission-denied');

export default function useIpGrant (companyId, isRequired) {
  const [result, setResult] = useState({});
  useEffect(() => {
    if(!companyId || !isRequired) return setResult({});

    const grant = async () => {
      try {
        const { data: { ip } } = await grantIpAccess({ companyId });
        setResult({ companyId, status: 'granted', ip });
      } catch(e) {
        console.error(e);
        setResult(_ => isPermissionDenied(e) ? { companyId, status: 'denied', ip: e.details?.ip } : _.companyId === companyId ? _ : { companyId, status: 'error' });
      }
    };
    const onVisibilityChange = () => document.visibilityState === 'visible' && grant();
    grant();
    const intervalId = setInterval(grant, pollingInterval);
    document.addEventListener('visibilitychange', onVisibilityChange);
    return () => {
      clearInterval(intervalId);
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, [companyId, isRequired]);

  if(!isRequired) return { status: 'notRequired' };
  return result.companyId === companyId ? result : { status: 'pending' };
};
